import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import CourseContent from './components/CourseContent';
import Instructor from './components/Instructor';
import Gallery from './components/Gallery';
import Testimonials from './components/Testimonials';
import PaymentCTA from './components/PaymentCTA';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <CourseContent />
      <Instructor />
      <Gallery />
      <Testimonials />
      <PaymentCTA />
      <FAQ />
      <Footer />
    </div>
  );
}

export default App;
